export const getIPAddress = async () => {
  const response = await fetch('https://api.ipify.org?format=json');
  if (response.status === 200) {
    const data = await response.json();

    return data?.ip as string ?? '';
  }

  return '';
}